<template>
    <div>

        <section class="content">
        <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Cetak Tunggal</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>NOP</span>
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control" value="74" disabled>
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control" value="05" disabled>
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-3"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Nomor Surat</span>
                    </div>
                    <div class="col-sm-2">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-8"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Tahun</span>
                    </div>
                    <div class="col-sm-2">
                        <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-8"></div>
                </div>
                <br> <hr>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-10">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">print</i>Cetak</button>
                    </div>
                </div>
                <br>
        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
